/*

(fields: \[)(.*?)(',\n\s*)  ==> $1$',

(params: \{)([\n\s]*)?(.*?)(',\n\s*)   ==>   $1$3',

(grid: \[)([\n\s]*)?\[(.*?)\](,\n\s*)  ==>  $1[$3],

(\{id:)([\n\s]*)?(.*?)(\d),(\n\s*) ==> $1$3$4,*/


import { formatJsonLocation as fjl,formatLocation} from '../../components/renderers';
import { formatJsonDataset as fjd } from '../../components/renderers';

const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

const serviceconfig = {
  account: {
    service: {
      name: 'account',
      title: 'Account',
      key: 'rid',
      num: false,
      fields: ['rid','nam','shc','dsc','ati','atn','eni','enm','eti','aky','bii','bin','bic','cre','lgo','exi','sts','ast','stp',],
      params: {nam: 'Service',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['atc', 'Type'],['enm', 'Entity'],['cre', 'Credits'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 1, ops: {} },
        { id: 'ati',label: 'Account Type',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'accounttype' }},
        { id: 'eni',label: 'Entity',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'entity' },chs: ['bii']},
        { id: 'bii',label: 'Fund',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'fund' },pns: ['eni']},
        { id: 'lgo',label: 'Logo',type: 'if',req: 0,ops: { preview: true }},
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  activity: {
    service: {
      name: 'activity',
      title: 'Activity',
      key: 'rid',
      num: true,
      fields: ['rid','cli','cln','clc','sti','stn','svi','svn','asi','asn','dcd','tki','rfi','par','exi','dtl','sts','ast','stp',],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',dsi: 'District',rgi: 'Region',sts: 'Status',},
      grid: [['dcd', 'Date'],['rfi', 'Reference'],['svn', 'Service'],['stn', 'Type'],['cln', 'Client'],['clc', 'Client Code'],['tki', 'Tracking ID'],['asn', 'Activity Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'cli',label: 'Client',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'client' }},
        { id: 'svi',label: 'Service',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'service' }},
        { id: 'ati',label: 'Activity Status',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'activitystatus' }},
        { id: 'tki', label: 'Tracking ID', type: 'rf', req: 0, ops: {} },
        { id: 'rfi', label: 'Reference ID', type: 'rf', req: 0, ops: {} },
        { id: 'par', label: 'Parameters', type: 'rf', req: 0, ops: {} },
        { id: 'exi', label: 'Extra Info', type: 'rf', req: 0, ops: {} },
        { id: 'dtl', label: 'Details', type: 'rf', req: 0, ops: {} },
        { id: 'sts',label: 'Record Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
        { id: 'stp', label: 'Last Updated', type: 'rf', req: 0, ops: {} },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }},

  activitystatus: {
    service: {
      name: 'activitystatus',
      title: 'Activity Statuses',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'sts', 'ast', 'stp'],
      params: {nam: 'Name',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['name', 'Name'],['shc', 'Code'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam',label: 'Name',type: 'tf',req: 1,ops: {},},
        { id: 'shc',label: 'Code',type: 'tf',req: 1,ops: {},},
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Record Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  api: {
    service: {
      name: 'api',
      title: 'API',
      key: 'rid',
      num: true,
      fields: ['rid','nam','shc','dsc','ati','acn','prn','cuc','chn','sts','ast','stp',],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'], ["shc", "Code"],['dsc', 'Description'],['dsc', 'Type'],['acn', 'Account'],['prn', 'Provider'],['cuc', 'Currency'],['chn', 'Channel'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', col: 1, req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', col: 1, req: 0, ops: {} },
        { id: 'dsc',label: 'Description',type: 'ta',col: 1,req: 1,ops: {},},
        { id: 'ati',label: 'API Type',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'bcs', s: 'apitype' }},
        { id: 'aci',label: 'API Account',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'account' }},
        { id: 'pri',label: 'API Provider Type',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'bcs', s: 'providertype' }},

        { id: 'cui',label: 'Currency',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'currency' }},

        { id: 'chi',label: 'Channel',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'channel' }},

        { id: 'amk', label: 'Access Mask', type: 'nf', req: 1, ops: {} },
        { id: 'cfg',label: 'Configuration',type: 'jf',col: 2,req: 0,ops: { rows: 2, rowsMax: 3 }},
        { id: 'req',label: 'Request',type: 'jf',col: 2,req: 0,ops: { rows: 2, rowsMax: 3 }},
        { id: 'res',label: 'Response',type: 'jf',req: 0,col: 2,ops: { rows: 2, rowsMax: 3 }},
        { id: 'exi',label: 'Extra Info',type: 'jf',col: 2,req: 0,ops: { rows: 2, rowsMax: 3 }},
        { id: 'sts',label: 'Status',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'column', edit: 'column', delete: 'dialog', view: 'column' }},

  apiaccess: {
    service: {
      name: 'apiaccess',
      title: 'API Access',
      key: 'rid',
      num: true,
      fields: ['rid','eni','enm','aci','acn','api','apn','apc','chc','prc','coc','cuc','aco','mco','mst','sts','ast','stp',],
      params: { enm: 'Entity', acn: 'Account', apn: 'API', sts: 'Status' },
      grid: [['enm', 'Entity'],['acn', 'Account'],['apc', 'API'],['aco', 'APICode'],['aky', 'APIKey'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Entity', v: 'enm' },{ t: 'Account', v: 'acn' },],def: 'enm',},
      eform: [
        { id: 'acn', label: 'Account', type: 'rf', req: 0, ops: {} },
        { id: 'svc', label: 'Service', type: 'rf', req: 0, ops: {} },
        { id: 'coc', label: 'Country', type: 'rf', req: 0, ops: {} },
        { id: 'apc', label: 'API', type: 'rf', req: 0, ops: {} },
        { id: 'moc', label: 'Mode', type: 'rf', req: 0, ops: {} },
        { id: 'prc', label: 'Provider', type: 'rf', req: 0, ops: {} },
        { id: 'chc', label: 'Channel', type: 'rf', req: 0, ops: {} },
        { id: 'cuc', label: 'Currency', type: 'rf', req: 0, ops: {} },
        { id: 'aco', label: 'API Code', type: 'rf', req: 0, ops: {} },
        { id: 'aky', label: 'API Key', type: 'rf', req: 0, ops: {} },
        { id: 'rst', label: 'Reset', type: 'sw', req: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: false,
    actions: { reset: 'Renew', view: 'View' },
    panels: { reset: 'simple', view: 'simple' },
  },

  apiaccessnew: {
    service: {
      name: 'apiaccess',
      title: 'API Access',
      key: 'rid',
      num: true,
      fields: ['rid','eni','enm','aci','acn','api','apn','aco','mco','mst','sts','ast','stp',],
      params: { enm: 'Entity', acn: 'Account', apn: 'API', sts: 'Status' },
      grid: [['enm', 'Entity'],['acn', 'Account'],['apn', 'API'],['aco', 'API Code'],['mco', 'Master'],['mst', 'MStatus'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: {
        mnu: [
          { t: 'Entity', v: 'enm' },
          { t: 'Account', v: 'acn' },
        ],
        def: 'enm',
      },
      eform: [
        { id: 'aci',label: 'Account',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'account' },
          off: ['edit'],
        },
        { id: 'api',label: 'API',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'api' },
          off: ['edit'],
        },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: 'server',
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  apirequest: {
    service: {
      name: 'apirequest',
      title: 'API Request',
      num: true,
      fields: ['rid','rqi','dcd','agi','agn','agc','rto','rbo','rin','cco','chn','sco','stx','exi','sts','stp',],
      grid: [['dcd', 'Date'],['rqi', 'RequestID'],['agn', 'Agent'],['rto', 'Token'],['cco', 'Code'],['chn', 'Channel'],['sco', 'Statuscode'],['sts', 'Status'],['stp', 'Stamp'],],
	    menu: { mnu: [{ t: 'Date', v: 'sdt' },{ t: 'Code', v: 'cco' },],def: 'cco',},
      eform: [
        { id: 'sco', label: 'Status Code', type: 'tf', req: 1, ops: {} },
        { id: 'stx', label: 'Status Text', type: 'ta', req: 0, ops: {} },
      ],
    },
    create: false,
    panels: { edit: 'simple', view: 'result', close: 'dialog',check: 'dialog', print: 'result'}},

  channel: {
    service: {
      name: 'channel',
      title: 'Channel',
      key: 'rid',
      num: false,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Channel',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  apitype: {
    service: {
      name: 'apitype',
      title: 'API Type',
      key: 'rid',
      num: false,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Type',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  audit: {
    service: {
      name: 'audit',
      title: 'Audit',
      key: 'rid',
      num: false,
      fields: ['rid','nam','shc','dsc','ati','atn','eni','enm','eti','aky','bii','bin','bic','cre','lgo','exi','sts','ast','stp',],
      params: {nam: 'Service',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['act', 'Action'],,['nam', 'Name'],['rnm', 'Role'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'ati',label: 'Account Type',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', f: 'accounttype' }},
        { id: 'eni',label: 'Entity',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'entity' }},
        { id: 'cre', label: 'Credit', type: 'nf', req: 0, ops: {} },
        { id: 'lgo', label: 'Logo', type: 'ff', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  billing: {
    service: {
      name: 'billing',
      title: 'Billing',
      key: 'rid',
      num: false,

      fields: ['rid','nam','fco','shc','eni','enm','eti','enc','cui','cur','bal','dsc','dcd','rmk','exi','sts','stp',],
      params: {nam: 'Fund',fco: 'Code',shc: 'ShortCode',enm: 'Entity',enc: 'Entity Code',cuc: 'Currency',bal: 'Balance',dsc: 'Description',dcd: 'Created',rmk: 'Remarks',exi: 'ExtraInfo',sts: 'Status',stp: 'Stamp',},
      grid: [['nam', 'Account'],['fco', 'Code'],['shc', 'ShortCode'],['enm', 'Entity'],['cur', 'Currency'],['bal', 'Balance'],['dsc', 'Description'],['dcd', 'Created'],['exi', 'Info'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'fco',label: 'Code',type: 'tf',req: 0,ops: {},off: ['add', 'edit'],
        },
        { id: 'shc', label: 'ShortCode', type: 'tf', req: 0, ops: {} },
        { id: 'eni',label: 'Entity',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'entity' }},
        { id: 'cui',label: 'Currency',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'currency' }},
        { id: 'bal',label: 'Balance',type: 'nf',req: 0,ops: {},off: ['add', 'edit'],
        },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'rmk', label: 'Remarks', type: 'ta', req: 0, ops: {} },
        { id: 'exi', label: 'ExtraInfo', type: 'jf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: false,
    actions: { view: 'View', check: 'Check' },
    panels: { view: 'simple', check: 'Dialog' },
    formatters: { grid: { exi: fjd } }},

  client: {
    service: {
      name: 'client',
      title: 'client',
      key: 'rid',
      num: true,
      fields: ['rid','nam','shc','eni','enn','lci','lcn','lcc','aky','acl','con','exi','dtl','sts','ast','stp',],
      grid: [['nam', 'Client Name'],['loc', 'Location'],['pho', 'Contact'],['com', 'Details'],['acs', 'Accounts'],['fus', 'Funds'],['uss', 'Users'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' }],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Short Code', type: 'tf', req: 1, ops: {} },
        { id: 'eni',label: 'Entity',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'entity' }},
        { id: 'lci',label: 'Location',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'location' }},
        { id: 'aky',label: 'Access Key',type: 'nf',req: 0, ops: {params: { s: 'client', a: 'access' },conf: { recField: 'rid' }}},
        { id: 'con', label: 'Contact', type: 'tf', req: 1, ops: {} },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'dtl', label: 'Details', type: 'tf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ]
    },
    create: true,
    actions: { add: 'Add', view: 'View'},
    panels: { add: 'wizard', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }
  },

  compliancetype: {
    service: {
      name: 'compliancetype',
      title: 'Compliance Types',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['stp', 'Stamp'],],
	    menu: { mnu: [{ t: 'Name', v: 'nam' }], def: 'nam' },
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
  },

  configuration: {
    service: {
      name: 'configuration',
      title: 'Configuration',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'val', 'sts', 'ast', 'stp'],
      params: {nam: 'Name',shc: 'Code',dsc: 'Description',val: 'Value',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['val', 'Value'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'val', label: 'Value', type: 'tf', req: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  connection: {
    service: {
      name: 'connection',
      title: 'Connection',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'val', 'sts', 'ast', 'stp'],
      grid: [['nam', 'Name'],['shc', 'Code'],['val', 'Value'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
	    menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'val', label: 'Value', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  context: {
    service: {
      name: 'context',
      title: 'Context',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'aky', 'acl', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',aky: 'Access Key',acl: 'Access Level',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['aky', 'Access Key'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'aky',label: 'Access Key',type: 'mf',req: 1,ops: {
            params: { s: 'context', a: 'access' },
            conf: { recField: 'rid' }}},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  customer: {
    service: {
      name: 'customer',
      title: 'Customer',
      fields: ['rid','fnm','mnm','lnm','nam','gdi','mbn','dcd','aci','acn','acc','bci','coi','coy','cos','ano','anm','cui','cuy','cus','bri','bnm','bcd','iti','itn','itc','idn','idy','tel','knm','krn','kcn','rmk','sts','ast','stp',],
      grid: [['dcd', 'Date'],['nam', 'Name'],['gdi', 'Gender'],['acn', 'Account'],['bnm', 'Branch'],['bci', 'Reference'],['mbn', 'Mobile'],['idy', 'ID'],['coy', 'Country'],['sts', 'Status'],['stp', 'Stamp'],],
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'fnm', label: 'Firstname', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'mnm', label: 'Middlename', type: 'tf', req: 0, col: 1, ops: {} },
        { id: 'lnm', label: 'Lastname', type: 'ta', req: 0, col: 1, ops: {} },
        { id: 'gdi',label: 'Gender',type: 'fa',req: 0,col: 1,ops: {},cp: { t: 'lcs', s: 'gender' }},
        { id: 'mbn',label: 'Mobile',type: 'tf',req: 0,col: 1,ops: { type: 'tel' }},
        { id: 'aci',label: 'Service',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'idtype' }},
        { id: 'bci',label: 'ServiceID',type: 'tf',req: 0,col: 1,ops: { type: 'tel' }},
        { id: 'coi',label: 'Country',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'idtype' }},
        { id: 'iti',label: 'ID Type',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'idtype' }},
        { id: 'idn', label: 'ID No', type: 'tf', req: 0, col: 1, ops: {} },
        { id: 'cui',label: 'Currency',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'idtype' }},
        { id: 'bri',label: 'Branch',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'idtype' }},
        { id: 'ano',label: 'Account No',type: 'tf',req: 0,col: 1,ops: { type: 'tel' }},
        { id: 'anm',label: 'Account Name',type: 'tf',req: 0,col: 1,ops: { type: 'tel' }},
        { id: 'ctn',label: 'Contact',type: 'tf',req: 0,col: 1,ops: { type: 'tel' }},
        { id: 'knm',label: 'Kin Name',type: 'tf',req: 0,col: 1,ops: { type: 'tel' }},
        { id: 'kre',label: 'Kin Relation',type: 'tf',req: 0,col: 1,ops: {},},
        { id: 'kco',label: 'Kin Contact',type: 'tf',req: 0,col: 1,ops: { type: 'tel' }},
        { id: 'rmk', label: 'Remarks', type: 'ta', req: 0, col: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,col: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: {
      add: 'wizard',
      edit: 'column',
      delete: 'dialog',
      view: 'simple',
      man: 'tab',
      close: 'dialog',
    }},

  dashmeta: {
    service: {
      name: 'dashmeta',
      title: 'Dashmeta',
      fields: ['rid','nam','shc','dsc','dti','dtn','dtc','ttl','dgp','dfm','dva','dun','col','pal','ico','exi','sts','ast','stp',],
      grid: [['nam', 'Name '],['shc', 'Code'],['dtn', 'Dashtype Name'],['ttl', 'Tittle'],['dgp', 'Data Group'],['dfm', 'Data Format'],['dva', 'Data Value'],['exi', 'Extra Info'],['sts', 'Status'],['stp', 'Stamp'],],//':nam,:shc,:dsc,:dti,:dtn,:dtc,:ttl,:dgp,:dfm,:dva,:dun,:col,:pal,:ico,:exi,:sts'
      menu: {
        mnu: [
          { t: 'Customer', v: 'nam' },
          { t: 'Code', v: 'shc' },
        ],
        def: 'nam',
      },
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'shc', label: 'Shortcode', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'dti',label: 'Dash Type ID',type: 'fa',req: 1,col: 1,ops: {},cp: { t: 'bcs', s: 'dashtype' }},
        { id: 'dtn',label: 'Dash Type Name',type: 'tf',req: 1,col: 1,ops: {},},
        { id: 'dtc',label: 'Dash Type Code',type: 'tf',req: 0,col: 1,ops: {},},
        { id: 'ttl', label: 'Tittle', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'dgp', label: 'Data Group', type: 'tf', req: 0, col: 1, ops: {} },
        { id: 'dfm',label: 'Data Format',type: 'tf',req: 0,col: 1,ops: {},},
        { id: 'dva', label: 'Data Value', type: 'tf', req: 0, col: 2, ops: {} },
        { id: 'dun', label: 'Data Unit', type: 'tf', req: 0, col: 2, ops: {} },
        { id: 'col', label: 'Color', type: 'tf', req: 0, col: 2, ops: {} },
        { id: 'pal', label: 'Palette', type: 'tf', req: 0, col: 2, ops: {} },
        { id: 'ico', label: 'Icon', type: 'tf', req: 0, col: 2, ops: {} },
        { id: 'dsc',label: 'Description',type: 'tf',req: 0,col: 2,ops: {},},
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, col: 2, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,col: 2,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: {
      add: 'column',
      edit: 'column',
      delete: 'dialog',
      view: 'column',
      man: 'tab',
      close: 'dialog',
    },
    formatters: { grid: { exi: fjd } }},

  deposit: {
    service: {
      name: 'deposit',
      title: 'Deposit',
      key: 'rid',
      num: false,
      //

      fields: ['rid','tri','rfn','vdt','fui','fco','fsc','fcc','bal','enm','usi','usn','cui','cuc','amt','dtl','dcd','exi','sts','ast','stp',],
      params: {tri: 'Trackid',rfn: 'Reference',vdt: 'Value Date',fui: 'FundId',fco: 'FundCode',fsc: 'ShortCode',fcc: 'FundCurrency',bal: 'FundBalance',enm: 'Entity',usi: 'UserId',usn: 'Username',dci: 'CurrencyId',dcc: 'Currency',amt: 'Amount',dtl: 'Detail',dcd: 'Created',exi: 'ExtraInfo',sts: 'Status',ast: 'Astatus',stp: 'Stamp',},
      grid: [['tri', 'TrackId'],['rfn', 'Reference'],['vdt', 'Date'],['fco', 'Code'],['fsc', 'Shortcode'],['fcc', 'FundCur'],['bal', 'FundBal'],['enm', 'FundEntity'],['usn', 'User'],['amt', 'Amount'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'tri',label: 'Trackid',type: 'ai',req: 0,ops: {},off: ['add'],
        },
        { id: 'rfn',label: 'Reference',type: 'tf',req: 0,ops: {},off: ['add'],
        },
        { id: 'vdt', label: 'Date', type: 'df', req: 0, ops: {} },
        { id: 'aci',label: 'Account',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'account' }},
        { id: 'cui',label: 'Currency',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'currency' }},
        { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },
        { id: 'dtl', label: 'Details', type: 'ta', req: 0, ops: {} },
        { id: 'exi', label: 'ExtraInfo', type: 'jf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' },
          off: ['add'],
        },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }},

  depositrequest: {
    service: {
      name: 'depositrequest',
      title: 'Deposit Request',
      key: 'rid',
      num: false,
      //

      fields: ['rid','tri','rfn','vdt','fui','fco','fsc','fcc','bal','enm','usi','usn','cui','cuc','amt','dtl','dcd','exi','sts','ast','stp',],
      params: {tri: 'Trackid',rfn: 'Reference',vdt: 'Value Date',fui: 'FundId',fco: 'FundCode',fsc: 'ShortCode',fcc: 'FundCurrency',bal: 'FundBalance',enm: 'Entity',usi: 'UserId',usn: 'Username',dci: 'CurrencyId',dcc: 'Currency',amt: 'Amount',dtl: 'Detail',dcd: 'Created',exi: 'ExtraInfo',sts: 'Status',ast: 'Astatus',stp: 'Stamp',},
      grid: [
        ['fsc', 'Shortcode'],
        ['fcc', 'FundCur'],
        ['bal', 'FundBal'],
        ['enm', 'FundEntity'],
        ['usn', 'User'],
        ['amt', 'Amount'],
        ['sts', 'Status'],
        ['stp', 'Stamp'],
      ],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'tri',label: 'Trackid',type: 'ai',req: 0,ops: {},off: ['add'],},
        { id: 'rfn',label: 'Reference',type: 'tf',req: 0,ops: {},off: ['add']},
        { id: 'vdt', label: 'Date', type: 'df', req: 0, ops: {} },
        { id: 'aci',label: 'Account',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'account' }},
        { id: 'cui',label: 'Currency',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'currency' }},
        { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },
        { id: 'dtl', label: 'Details', type: 'ta', req: 0, ops: {} },
        { id: 'exi', label: 'ExtraInfo', type: 'jf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' },off: ['add']},
      ],
    },
    create: false,
    actions: { view: 'View'},
    panels: { view: 'simple' },
    formatters: { grid: { exi: fjd } }},

  topuprequest: {
    service: {
      name: 'topuprequest',
      title: 'Topup Request',
      key: 'rid',
      num: false,
      fields: ['rid','tri','rfn','vdt','fui','fco','fsc','fcc','bal','enm','usi','usn','cui','cuc','amt','dtl','dcd','exi','sts','ast','stp',],
      params: {tri: 'Trackid',rfn: 'Reference',vdt: 'Value Date',fui: 'FundId',fco: 'FundCode',fsc: 'ShortCode',fcc: 'FundCurrency',bal: 'FundBalance',enm: 'Entity',usi: 'UserId',usn: 'Username',dci: 'CurrencyId',dcc: 'Currency',amt: 'Amount',dtl: 'Detail',dcd: 'Created',exi: 'ExtraInfo',sts: 'Status',ast: 'Astatus',stp: 'Stamp',},
      grid: [['tri', 'TrackId'],['cur', 'Currency'],['coy', 'Country'],['net', 'Network'],['mbn', 'Mobile number'],['acc', 'Account'],['amt', 'Amount'],['sts', 'Status'],['dcd', 'Date'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'tri',label: 'Trackid',type: 'ai',req: 0,ops: {},off: ['add']},
        { id: 'rfn',label: 'Reference',type: 'tf',req: 0,ops: {},off: ['add']},
        { id: 'vdt', label: 'Date', type: 'df', req: 0, ops: {} },
        { id: 'aci',label: 'Account',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'account' }},
        { id: 'cui',label: 'Currency',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'currency' }},
        { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },
        { id: 'dtl', label: 'Details', type: 'ta', req: 0, ops: {} },
        { id: 'exi', label: 'ExtraInfo', type: 'jf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' },
          off: ['add'],
        },
      ],
    },
    create: false,
    actions: {
      view: 'View',
    },
    panels: { view: 'simple' },
    formatters: { grid: { exi: fjd } }},

  district: {
    service: {
      name: 'district',
      title: 'District',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'rgi', 'rgn', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',rgi: 'Region',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['rgn', 'Region'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'rgi',label: 'Region',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'region' }},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  entity: {
    service: {
      name: 'entity',
      title: 'Entity',
      key: 'rid',
      num: true,
      fields: ['rid','nam','eti','ety','adr','loc','ct1','ct2','fax','eml','web','com','ila','pla','sts','ast','stp',],
      params: {nam: 'Name',eti: 'EntityTypeId',ety: 'EntityType',adr: 'Address',sts: 'Status',},
      grid: [['nam', 'Name'],['ety', 'Type'],['loc', 'Location'],['ct1', 'Contact'],['eml', 'Email'],['web', 'Web'],['pla', 'PLA'],['ila', 'ILA'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Contact', v: 'ct1' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', col: 1, req: 1, ops: {} },
        { id: 'eti',label: 'Entity Type',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'bcs', s: 'entitytype' }},
        { id: 'adr', label: 'Address', type: 'ta', col: 1, req: 0, ops: {} },
        { id: 'loc', label: 'Location', type: 'tf', col: 1, req: 0, ops: {} },
        { id: 'ct1',label: 'Company Code',type: 'tf',col: 1,req: 0,ops: {helperText: 'Enter Company Registration Code',pattern: 'C[0-9]+'}},
        { id: 'ct2',label: 'Phone',type: 'tf',col: 1,req: 0,ops: { type: 'tel' }},
        { id: 'fax', label: 'Contact Person', type: 'tf', col: 2, req: 0, ops: {} },
        { id: 'eml',label: 'Email',type: 'tf',col: 2,req: 0,ops: { type: 'email' }},
        { id: 'web',label: 'web',type: 'tf',col: 2,req: 0,ops: { type: 'url' }},
        { id: 'com', label: 'Comments', type: 'ta', col: 2, req: 0, ops: {} },
        { id: 'ila',label: 'ILA',type: 'nf',col: 2,req: 0,ops: { type: 'range', min: 0, max: 10 },off: ['add', 'edit']},
        { id: 'pla',label: 'PLA',type: 'nf',col: 2,req: 0,ops: { type: 'range', min: 0, max: 10 },off: ['add', 'edit']},
        { id: 'sts',label: 'Status',type: 'fa',col: 2,req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'column', edit: 'column', delete: 'dialog', view: 'column' }},

  entitytype: {
    service: {
      name: 'entitytype',
      title: 'Entity Type',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'pls', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',
        pls: 'Privileges',
        sts: 'Status',
      },
      grid: [['nam', 'Name'],['pls', 'Privileges'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'pls', label: 'Privileges', type: 'ta', req: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  agent: {
    service: {
      name: 'agent',
      title: 'Agent',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',
        sts: 'Status',
      },
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  agency: {
    service: {
      name: 'agency',
      title: 'Agency',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  accounttype: {
    service: {
      name: 'accounttype',
      title: 'Account Type',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },

        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  agenttype: {
    service: {
      name: 'agenttype',
      title: 'Agent Type',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',
        sts: 'Status',
      },
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  agentcategory: {
    service: {
      name: 'agentcateogry',
      title: 'Agent Category',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',// pls: "Privileges",
        sts: 'Status',
      },
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  accessgroup: {
    service: {
      name: 'accessgroup',
      title: 'Agent Access Group',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'aky', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',pls: 'Access key',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['aky', 'Access Key'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'aky', label: 'Access key', type: 'nf', req: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  error: {
    service: {
      name: 'error',
      title: 'Error',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'msg', 'sts', 'ast', 'stp'],
      params: {nam: 'Error',shc: 'Code',dsc: 'Description',acl: 'Message',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['msg', 'Message'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'msg', label: 'Message', type: 'tf', req: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  frequency: {
    service: {
      name: 'frequency',
      title: 'Transaction Frequency',
      key: 'rid',
      num: true,
      fields: ['rid','nam','shc','dsc',
        'pes',
        'uni',
        'tot',
        'sts',
        'ast',
        'stp',
      ],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',dsi: 'District',rgi: 'Region',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['tot', 'Total'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'per', label: 'Period', type: 'tf', req: 1, ops: {} },
        { id: 'tot', label: 'Total', type: 'tf', req: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: false,
    actions: {add: 'Add',edit: 'Edit',
      del: 'Delete',
      delete: 'Delete',
      view: 'View',
    },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  limit: {
    service: {
      name: 'limit',
      title: 'Transaction Limit',
      key: 'rid',
      num: true,
      fields: ['rid','aci','acn','max','fri','frn','frc','frp','frv','sts','ast','stp',],
      params: {aci: 'AgentCategory',max: 'Max Limit',fri: 'Frequency',frp: 'Period',frv: 'Limit',sts: 'Status',},
      grid: [['acn', 'Category'],['max', 'Maximum'],['frc', 'Frequency'],['frn', 'Frequency'],['frp', 'Period'],['frv', 'Limit'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'aci',label: 'Category',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'agentcategory' }},
        { id: 'max', label: 'Maximum', type: 'nf', req: 0, ops: {} },
        { id: 'fri',label: 'Frequency',type: 'fa',req: 0,ops: {},cp: { t: 'bcs', s: 'frequency' }},
        { id: 'tot', label: 'Total', type: 'tf', req: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  fund: {
    service: {
      name: 'fund',
      title: 'Fund',
      key: 'rid',
      num: false,

      fields: ['rid','nam','fco','shc','eni','enm','eti','enc','cui','cur','bal','dsc','dcd','rmk','exi','sts','stp',],
      params: {nam: 'Fund',fco: 'Code',shc: 'ShortCode',enm: 'Entity',enc: 'Entity Code',cuc: 'Currency',bal: 'Balance',dsc: 'Description',dcd: 'Created',rmk: 'Remarks',exi: 'ExtraInfo',sts: 'Status',stp: 'Stamp',},
      grid: [['nam', 'Fund'],['fco', 'Code'],['shc', 'ShortCode'],['enm', 'Entity'],['cur', 'Currency'],['bal', 'Balance'],['dsc', 'Description'],['dcd', 'Created'],['exi', 'Info'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'fco',label: 'Code',type: 'tf',req: 0,ops: {},off: ['add', 'edit']},
        { id: 'shc', label: 'ShortCode', type: 'tf', req: 0, ops: {} },
        { id: 'eni',label: 'Entity',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'entity' }, off: ['edit']},
        { id: 'cui',label: 'Currency',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'currency' }, off: ['edit']},
        { id: 'bal',label: 'Balance',type: 'nf',req: 0,ops: {}, off: ['add', 'edit']},
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'rmk', label: 'Remarks', type: 'ta', req: 0, ops: {} },
        { id: 'exi', label: 'ExtraInfo', type: 'jf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }},

  fxrate: {
    service: {
      name: 'fxrate',
      title: 'Fx Rate',
      key: 'rid',
      num: false,
      fields: ['rid','sid','shc','did','dhc','rat','dcd','rmk','sts','stp',],
      params: {sid: 'ID',shc: 'ShortCode',did: 'ID',dhc: 'Code',rat: 'Rate',dcd: 'Created',rmk: 'Remarks',sts: 'Status',stp: 'Stamp',},
      grid: [['sid', 'ID'],['shc', 'ShortCode'],['did', 'ID'],['dhc', 'Code'],['rat', 'Rate'],['rmk', 'Remark'],['dcd', 'Created'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'sid', label: 'ID', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'ShortCode', type: 'tf', req: 0, ops: {} },
        { id: 'did', label: 'ID', type: 'tf', req: 1, ops: {} },
        { id: 'dhc', label: 'ShortCode', type: 'tf', req: 0, ops: {} },
        { id: 'rat', label: 'Rate', type: 'tf', req: 0, ops: {} },
        { id: 'rmk', label: 'Remarks', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: false,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }},

  fxhistory: {
    service: {
      name: 'fxhistory',
      title: 'Fx History',
      key: 'rid',
      num: false,

      fields: ['rid','sid','shc','did','dhc','rat','dcd','rmk','sts','stp',],
      params: {sid: 'ID',shc: 'ShortCode',did: 'ID',dhc: 'Code',rat: 'Rate',dcd: 'Created',rmk: 'Remarks',sts: 'Status',stp: 'Stamp',},
      grid: [['sid', 'ID'],['shc', 'ShortCode'],['did', 'ID'],['dhc', 'Code'],['rat', 'Rate'],['rmk', 'Remark'],['dcd', 'Created'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'sid', label: 'ID', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'ShortCode', type: 'tf', req: 0, ops: {} },
        { id: 'did', label: 'ID', type: 'tf', req: 1, ops: {} },
        { id: 'dhc', label: 'ShortCode', type: 'tf', req: 0, ops: {} },
        { id: 'rat', label: 'Rate', type: 'tf', req: 0, ops: {} },
        { id: 'rmk', label: 'Remarks', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: false,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }},

  location: {
    service: {
      name: 'location',
      title: 'Location',
      key: 'rid',
      num: true,
      fields: ['rid','nam','shc','dsc','dsi','dsn','rgi','rgn','geo','exi','sts','ast','stp',],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',dsi: 'District',rgi: 'Region',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['dsn', 'District'],['rgn', 'Region'],['geo', 'Geolocation'],['exi', 'ExtraInfo'],['sts', 'Status'],['stp', 'Stamp'],],
bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'dsi',label: 'District',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'district' }},
        { id: 'geo', label: 'Geolocation', type: 'gl', req: 1, ops: {} },
        { id: 'exi', label: 'ExtraInfo', type: 'jf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { geo: fjl, exi: fjd } }},

  loglevel: {
    service: {
      name: 'loglevel',
      title: 'Log Level',
      key: 'rid',
      num: true,
      fields: ['rid', 'stn', 'sty', 'sti', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Setting',shc: 'Code',typ: 'Type',val: 'Value',dtl: 'Details',sts: 'Status',},
      grid: [['stn', 'Name'],['sts', 'Status'],['stp', 'Stamp'],],
bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'stn',label: 'Name',type: 'tf',req: 1,ops: {},off: ['edit'],
        },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  privilege: {
    service: {
      name: 'privilege',
      title: 'Privilege',
      key: 'rid',
      num: false,
      fields: ['rid','nam','shc','mnm','smn','mng','lnm','ord','acl','btx','bfn','acf','ctx','sts','ast','stp',],
      params: {nam: 'Service',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Privilege'],['shc', 'Code'],['mnm', 'Menu'],['smn', 'Submenu'],['ord', 'Order'],['acl', 'Access'],['acf', 'Module'],['bfn', 'Action'],['btx', 'Label'],['ctx', 'Context'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Privilege', v: 'nam' },{ t: 'Code', v: 'shc' }],def: 'nam'},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'mnm', label: 'Menu', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'mng', label: 'Group', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'smn', label: 'Submenu', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'lnm', label: 'Language', type: 'tf', req: 1, col: 1, ops: {} },
        { id: 'ord', label: 'Order', type: 'tf', req: 1, col: 2, ops: {} },
        { id: 'acl',label: 'Access',type: 'ml',req: 1,col: 2,ops: { params: { s: 'role', a: 'find' }, conf: { keyField: 'aky' } }},
        { id: 'btx', label: 'Label', type: 'tf', req: 1, col: 2, ops: {} },
        { id: 'bfn', label: 'Action', type: 'tf', req: 1, col: 2, ops: {} },
        { id: 'acf', label: 'Module', type: 'tf', req: 1, col: 2, ops: {} },
        { id: 'ctx',label: 'Context',type: 'ml',req: 1,col: 2,ops: {params: { s: 'context', a: 'find' },conf: { keyField: 'aky' }},},
        { id: 'sts',label: 'Status',type: 'fa',req: 1,col: 2,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'column', edit: 'column', delete: 'dialog', view: 'column' }},

  profile: {
    service: {
      name: 'profile',
      title: 'Profile',
      key: 'rid',
      num: true,
      fields: ['rid','nam','fnm','onm','snm','unm','roi','rnm','eti','ety','eni','enm','rfi','ct1','ct2','eml','lvi','lvn','mct','sto','pla','ila','lst','flg','dct','lpd','lld','rmk','sts','ast','stp',],
      params: {nam: 'Status Name',sty: 'Type',sti: 'Status Id',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'],['unm', 'Username'],['ety', 'EntityType'],['rnm', 'Role'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'fnm', label: 'Firstname', type: 'tf', req: 1, ops: {} },
        { id: 'onm', label: 'Othername', type: 'rf', req: 1, ops: {} },
        { id: 'snm', label: 'Surname', type: 'rf', req: 1, ops: {} },
        { id: 'nam', label: 'Username', type: 'rf', req: 1, ops: {} },
        { id: 'unm', label: 'Username', type: 'rf', req: 1, ops: {} },
        { id: 'rnm', label: 'Role', type: 'rf', req: 1, ops: {} },
        { id: 'ety', label: 'Entity Type', type: 'rf', req: 1, ops: {} },
        { id: 'enm', label: 'Entity', type: 'rf', req: 1, ops: {} },
        { id: 'ct1', label: 'Mobile', type: 'rf', req: 1, ops: {} },
        { id: 'ct2', label: 'Code', type: 'rf', req: 1, ops: {} },
        { id: 'eml', label: 'Email', type: 'rf', req: 1, ops: {} },
        { id: 'lvn', label: 'Log Level', type: 'rf', req: 1, ops: {} },
        { id: 'mct', label: 'Messages', type: 'rf', req: 1, ops: {} },
        { id: 'sto', label: 'Session Timeout', type: 'rf', req: 1, ops: {} },
        { id: 'pla', label: 'Plain Login', type: 'rf', req: 1, ops: {} },
        { id: 'ila', label: 'Image Login', type: 'rf', req: 1, ops: {} },
        { id: 'lst', label: 'Login Status', type: 'rf', req: 1, ops: {} },
        { id: 'flg', label: 'Failed Login', type: 'rf', req: 1, ops: {} },
        { id: 'dct', label: 'Created', type: 'rf', req: 1, ops: {} },
        { id: 'lpd', label: 'Last Password', type: 'rf', req: 1, ops: {} },
        { id: 'lld', label: 'Last Login', type: 'rf', req: 1, ops: {} },
        { id: 'rmk', label: 'Remarks', type: 'rf', req: 1, ops: {} },
        { id: 'ast', label: 'Status', type: 'rf', req: 1, ops: {} },
        { id: 'stp', label: 'Last Updated', type: 'rf', req: 1, ops: {} },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  provider: {
    service: {
      name: 'provider',
      title: 'Service Providers',
      key: 'rid',
      num: true,
      fields: ['rid','nam','shc','dsc','pti','ptn','aci','acn','coi','ctn','adr','ref','dba','cda','cfg','sts','ast','stp',],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',ptn: 'Type',acn: 'Account',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['ptn', 'Type Name'],['acn', 'Account name'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'pti',label: 'Provider type',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'providertype' }},
        { id: 'aci',label: 'Account type',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'accounttype' }},
        { id: 'coi',label: 'Country',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'country' }},
        { id: 'ctn', label: 'Contact', type: 'tf', req: 1, ops: {} },
        { id: 'adr', label: 'Address', type: 'ta', req: 1, ops: {} },
        { id: 'ref', label: 'Reference', type: 'tf', req: 0, ops: {} },
        { id: 'dba', label: 'OP Account', type: 'tf', req: 0, ops: {} },
        { id: 'cda', label: 'SE Account', type: 'tf', req: 0, ops: {} },
        { id: 'cfg',label: 'Configuration',type: 'jf',req: 0,ops: { rows: 2, rowsMax: 3 }},
        { id: 'exi',label: 'Extra Info',type: 'jf',req: 0,ops: { rows: 2, rowsMax: 3 }},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  providertype: {
    service: {
      name: 'providertype',
      title: 'Service Providers Types',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },

        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  register: {
    service: {
      name: 'register',
      title: 'Register',
      key: 'rid',
      num: false,
      fields: ['rid','rfn','tri','rqi','dcd','tdt','soi','aci','acn','acc','tci','tcn','tcc','csi','csn','cco','mbn','gdi','idn','ctn','chi','chn','chc','api','apn','apc','apt','dcd','xti','xtn','xtc','cui','cur','cuc','amt','dsc','req','att','xsi','xsn','xsc','rsc','rst','res','exi','dtl','sts','stp',],
      grid: [['dcd', 'Date'],['rfn', 'Reference'],['csn', 'Customer'],['mbn', 'Mobile'],['tcn', 'Center'],['xtc', 'Type'],['xsc', 'Test Status'],['dtl', 'Detail'],['rst', 'Status'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},

      eform: [
        { id: 'aai',label: 'Service',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'apiaccess' },
          off: ['edit', 'view'],
        },
        { id: 'apn',label: 'Service',type: 'rf',req: 0,ops: {},off: ['add'],
        },
        { id: 'xti',label: 'Contribution Type',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'testingtype' },
          off: ['edit', 'view'],
        },
        { id: 'xtn',label: 'Contribution Type',type: 'rf',req: 0,ops: {},off: ['add'],
        },
        { id: 'tdt',label: 'Contribution Date',type: 'df',req: 0,ops: {},off: ['edit'],
        },
        { id: 'dsc',label: 'Description',type: 'tf',req: 1,ops: {},off: ['edit'],
        },
        { id: 'csi',label: 'Customer',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'customer' },
          off: ['edit'],
        },
        { id: 'tci',label: 'Center',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'testingcenter' }},
        { id: 'xsi',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'testingstatus' }},
        { id: 'rst', label: 'Result', type: 'tf', req: 1, ops: {} },
        { id: 'rfn',label: 'Reference',type: 'rf',req: 0,ops: {},off: ['add', 'edit'],
        },
        { id: 'dtl',label: 'Notes',type: 'ta',req: 0,ops: {},off: ['edit'],
        },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' },
          off: ['add'],
        },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  reportheader: {
    service: {
      name: 'reportheader',
      title: 'Report Header',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'rpi', 'rpn', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',rpi: 'Report',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['rpn', 'Report'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'rpi',label: 'Report',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'report' }},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  reportsettings: {
    service: {
      name: 'reportsettings',
      title: 'Report Settings',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'rpi', 'rpn', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',rpi: 'Report',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['rpn', 'Report'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'rpi',label: 'Report',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'report' }},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  reportsummary: {
    service: {
      name: 'reportsummary',
      title: 'Report Summary',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'rpi', 'rpn', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',rpi: 'Report',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['rpn', 'Report'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'rpi',label: 'Report',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'report' }},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  role: {
    service: {
      name: 'role',
      title: 'Role',
      key: 'rid',
      num: true,
      fields: ['rid','nam','dsc','sto','aky','acl','eti','ety','sts','ast','stp',],
      params: {nam: 'Service',dsc: 'Description',sto: 'Timeout',sts: 'Status',},
      grid: [['nam', 'Name'],['dsc', 'Description'],['sto', 'Session Timeout'],['aky', 'Access Key'],['acl', 'Access Level'],['ety', 'EntityType'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' }, { t: 'Description', v: 'dsc' },],
        def: 'nam',
      },
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'eti',label: 'Entity Type',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'entitytype' }},
        { id: 'aky',label: 'Access Key',type: 'mf',req: 0,ops: { params: { s: 'role', a: 'access' }, conf: { recField: 'rid' }}},
        { id: 'sto', label: 'Timeout', type: 'nf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  service: {
    service: {
      name: 'service',
      title: 'Service',
      key: 'rid',
      num: true,
      fields: ['rid','nam','sti',// "acl",l hav
        'dsc',
        'sky',
        'exi',
        'sts',
        'ast',
        'stp',
      ],
      grid: [['nam', 'Service'],['sti', 'Type'],['shc', 'ShortCode'],['ask', 'Access Key'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: {
        mnu: [
          { t: 'Service', v: 'nam' },
        ],
        def: 'nam',
      },
      form: ['aci', 'svi', 'sts'],
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'sti',label: 'Type',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'servicetype' }},
        { id: 'ask',label: 'Access Key',type: 'tf',req: 1,ops: {},},
        { id: 'shc',label: 'Short Code',type: 'tf',req: 1,ops: {},},
        { id: 'dsc',label: 'Description',type: 'ta',req: 1,ops: { minRows: 2, maxRows: 3 }},
        { id: 'exi',label: 'Extra Info',type: 'jf',req: 0,ops: { rows: 2, rowsMax: 3 }},
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  servicemap: {
    service: {
      name: 'servicemap',
      title: 'Service Map',
      key: 'rid',
      num: true,
      fields: ['rid','svi','sti','svn','svc','app','fun','gts','ope','pro','tid','mid','ext','exi','dtl','sts','ast','stp',],
      grid: [['svn', 'Service '],['coc', 'Country'],['smc', 'Mode'],['apc', 'API'],['rnk', 'Priority'],['ast', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'smc', v: 'Mode' }], def: 'smc' },
      form: ['aci', 'svi', 'sts'],
      eform: [
        { id: 'svi',label: 'Service',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'service' }},
        { id: 'coi',label: 'Country',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'country' }},
        { id: 'smi',label: 'Mode',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'servicemode' }},
        { id: 'api',label: 'API',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'api' }},
        { id: 'rnk', label: 'Priority', type: 'nf', req: 1, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  servicelog: {
    service: {
      name: 'servicelog',
      title: 'Service Logging',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'aky', 'acl', 'dsc', 'sts', 'ast', 'stp'],
      grid: [['nam', 'Name'],['shc', 'Short Code'],['acl', 'Access Level'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: {
        mnu: [
          { t: 'Name', v: 'nam' },
          { t: 'svn', v: 'Service' },
        ],
        def: 'nam',
      },
      form: ['aci', 'svi', 'sts'],
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Short Code', type: 'tf', req: 1, ops: {} },
        { id: 'aky',label: 'Access Key',type: 'mf',req: 1,ops: {
            params: { s: 'servicelog', a: 'access' },
            conf: { recField: 'rid' }}},
        { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: false,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  servicemode: {
    service: {
      name: 'servicemode',
      title: 'Service Modes',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      grid: [['nam', 'Name'],['shc', 'Service Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: {
        mnu: [
          { t: 'Name', v: 'nam' },
          { t: 'shc', v: 'Service' },
        ],
        def: 'nam',
      },
      form: ['aci', 'svi', 'sts'],
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Service Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  servicetype: {
    service: {
      name: 'servicetype',
      title: 'Service Types',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'sts', 'ast', 'stp'],
      grid: [['nam', 'Name'],['shc', 'Short Code'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: {
        mnu: [
          { t: 'Name', v: 'nam' },
          { t: 'shc', v: 'Short Code' },
        ],
        def: 'nam',
      },
      form: ['aci', 'shc', 'sts'],
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Short Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  setting: {
    service: {
      name: 'setting',
      title: 'Setting',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'typ', 'val', 'dtl', 'sts', 'ast', 'stp'],
      params: {nam: 'Setting',shc: 'Code',typ: 'Type',val: 'Value',dtl: 'Details',sts: 'Status',},
      grid: [['nam', 'Setting'],['shc', 'Code'],['typ', 'Type'],['val', 'Value'],['dtl', 'Details'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Setting', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'typ', label: 'Type', type: 'tf', req: 1, ops: {} },
        { id: 'val', label: 'Value', type: 'tf', req: 1, ops: {} },
        { id: 'dtl', label: 'Detail', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  settlement: {
    service: {
      name: 'settlement',
      title: 'Settlement',
      key: 'rid',
      num: true,
      fields: ['rid','dcd','rqi','rfn','txd','na1','na2','amt','dba','cda','ssi','ssn','ssc','sts','ast','stp',],
      params: {nam: 'Setting',shc: 'Code',typ: 'Type',val: 'Value',dtl: 'Details',sts: 'Status',},
      grid: [['txd', 'Transaction Date'],['na1', 'Naration 1'],['na2', 'Naration 2'],['amt', 'Amount'],['dba', 'Debit Account'],['cda', 'Credit Account'],['ssn', 'Settlement Status'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Setting', v: 'nam' },{ t: 'Code', v: 'shc' }],def: 'nam'},
      eform: [
        { id: 'dcd',label: 'Date Created',type: 'tf',req: 0,col: 1,ops: {},},
        { id: 'rqi', label: 'Request ID', type: 'tf', req: 0, col: 1, ops: {} },
        { id: 'rfn', label: 'Reference', type: 'tf', req: 0, col: 1, ops: {} },
        { id: 'txd',label: 'Transaction Date',type: 'tf',req: 0,col: 1,ops: {},},
        { id: 'na1', label: 'Naration 1', type: 'tf', req: 0, col: 1, ops: {} },
        { id: 'na2', label: 'Naration 2', type: 'tf', req: 0, col: 1, ops: {} },
        { id: 'amt', label: 'Amount', type: 'tf', req: 0, col: 2, ops: {} },
        { id: 'dba',label: 'Debit Account',type: 'tf',req: 0,col: 2,ops: {},},
        { id: 'cda',label: 'Credit Account',type: 'tf',req: 0,col: 2,ops: {},},
        { id: 'ssi',label: 'Settlement Status',type: 'fa',req: 0,col: 2,ops: {},cp: { t: 'bcs', s: 'settlementstatus' }},
        { id: 'ssc',label: 'Settlement Status Code',type: 'tf',req: 0,col: 2,ops: {},},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,col: 2,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: false,
    actions: { del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { delete: 'dialog', view: 'simple' }},

  status: {
    service: {
      name: 'status',
      title: 'Status',
      key: 'rid',
      num: true,
      fields: ['rid', 'stn', 'sty', 'sti', 'dsc', 'sts', 'ast', 'stp'],
      params: {nam: 'Status Name',sty: 'Type',sti: 'Status Id',dsc: 'Description',sts: 'Status',},
      grid: [['nam', 'Name'],['sty', 'Type'],['sti', 'Status ID'],['dsc', 'Description'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'sty', label: 'Type', type: 'tf', req: 1, ops: {} },
        { id: 'sti', label: 'Status ID', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  transaction: {
    service: {
      name: 'transaction',
      title: 'Transactions',
      num: true,
      fields: ['rid','rfn','tri','rqi','dcd','tdt','aci','acn','acc','fui','fun','fus','svi','svn','svc','eni','coi','coy','coc','xti','xtn','xtc','xsi','xsn','xsc','dba','dbr','cda','cdr','cui','cuc','amt','dtl','rsn','rst','req','res','rmk','exi','sts','stp',],
      grid: [['dcd', 'Date'],['rfn', 'Reference'],['acc', 'Account'],['xtc', 'Type'],['svc', 'Service'],['coy', 'Country'],['cuc', 'Currency'],['amt', 'Amount'],['dsc', 'Description'],['xsc', 'Status'],],
	    menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'rfn', label: 'Reference', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'tri',label: 'Tracking Id',type: 'rf',col: 1,req: 0,ops: {},},
        { id: 'rqi', label: 'Request Id', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'tdt',label: 'Transaction Date',type: 'rf',col: 1,req: 0,ops: {},},
        { id: 'acn',label: 'Client Name',type: 'rf',col: 1,req: 0,ops: {},},
        { id: 'acc',label: 'Client Code',type: 'rf',col: 1,req: 0,ops: {},},
        { id: 'fus', label: 'Billing ID', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'svn', label: 'Service', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'coy', label: 'Country', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'tyc', label: 'Type Code', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'xtn', label: 'Type Name', type: 'rf', col: 1, req: 0, ops: {} },
        //{ id: 'brn',label:'Branch Name',type:'rf',col:1,req:0,ops:{}},
        //{ id: 'brc',label:'Branch Code',type:'rf',col:2,req:0,ops:{}},
        { id: 'dba',label: 'Debit Account',type: 'rf',col: 2,req: 0,ops: {},},
        { id: 'cda',label: 'Credit Account',type: 'rf',col: 2,req: 0,ops: {},},
        { id: 'amt', label: 'Amount', type: 'rf', col: 2, req: 0, ops: {} },
        { id: 'dsc',label: 'Description',type: 'rf',col: 2,req: 0,ops: {},},
        { id: 'xsc', label: 'Status', type: 'rf', col: 2, req: 0, ops: {} },
        { id: 'req', label: 'Request', type: 'jf', col: 2, req: 0, ops: {} },
        { id: 'res', label: 'Response', type: 'jf', col: 2, req: 0, ops: {} },
        { id: 'exi', label: 'Extrainfo', type: 'jf', col: 2, req: 0, ops: {} },
        { id: 'stp', label: 'Stamp', type: 'rf', col: 2, req: 0, ops: {} },
      ],
    },
    create: false,
    panels: { view: 'column', close: 'dialog', check: 'dialog', print: 'result'},
    formatters: { grid: { req: fjd, res: fjd, exi: fjd } }},

  reversal: {
    service: {
      name: 'reversal',
      title: 'Reversal',
      num: true,
      fields: ['rid','rfn','tri','rqi','dcd','tdt','aci','acn','acc','fui','fun','fus','svi','svn','svc','eni','coi','coy','coc','xti','xtn','xtc','xsi','xsn','xsc','dba','dbr','cda','cdr','cui','cuc','amt','dtl','rsn','rst','req','res','rmk','exi','sts','stp',],
      grid: [['dtc', 'Date'],['rfn', 'Reference No'],['req', 'Request'],['res', 'Response'],['sts', 'Status'],['stp', 'Stamp'],],
	    menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'rfn', label: 'Reference', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'tri',label: 'Tracking Id',type: 'rf',col: 1,req: 0,ops: {},},
        { id: 'rqi', label: 'Request Id', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'tdt',label: 'Transaction Date',type: 'rf',col: 1,req: 0,ops: {},},
        { id: 'acn',label: 'Client Name',type: 'rf',col: 1,req: 0,ops: {},},
        { id: 'acc',label: 'Client Code',type: 'rf',col: 1,req: 0,ops: {},},
        { id: 'fus', label: 'Billing ID', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'svn', label: 'Service', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'coy', label: 'Country', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'tyc', label: 'Type Code', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'xtn', label: 'Type Name', type: 'rf', col: 1, req: 0, ops: {} },
        { id: 'dba',label: 'Debit Account',type: 'rf',col: 2,req: 0,ops: {},},
        { id: 'cda',label: 'Credit Account',type: 'rf',col: 2,req: 0,ops: {},},
        { id: 'amt', label: 'Amount', type: 'rf', col: 2, req: 0, ops: {} },
        { id: 'dsc',label: 'Description',type: 'rf',col: 2,req: 0,ops: {},},
        { id: 'xsc', label: 'Status', type: 'rf', col: 2, req: 0, ops: {} },
        { id: 'req', label: 'Request', type: 'jf', col: 2, req: 0, ops: {} },
        { id: 'res', label: 'Response', type: 'jf', col: 2, req: 0, ops: {} },
        { id: 'exi', label: 'Extrainfo', type: 'jf', col: 2, req: 0, ops: {} },
        { id: 'stp', label: 'Stamp', type: 'rf', col: 2, req: 0, ops: {} },
      ],
    },
    create: false,
    panels: { view: 'column', close: 'dialog', check: 'dialog', print: 'result'},
    formatters: { grid: { req: fjd, res: fjd, exi: fjd } }},

  transactiontype: {
    service: {
      name: 'transactiontype',
      title: 'Transaction Type',
      key: 'rid',
      num: true,
      fields: ['rid', 'nam', 'shc', 'dsc', 'dba', 'cda', 'sts', 'ast', 'stp'],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',dba: 'Debi Account',cda: 'Credit Account',sts: 'Status',},
      grid: [['nam', 'Name'],['shc', 'Code'],['dsc', 'Description'],['dba', 'Debit Account'],['cda', 'Credit Account'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' },{ t: 'Code', v: 'shc' },],def: 'nam',},
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'dba',label: 'Debit Account',type: 'tf',req: 0,ops: { pattern: '[0-9]{16}' }},
        { id: 'cda',label: 'Credit Account',type: 'tf',req: 0,ops: { pattern: '[0-9]{16}' }},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  uicontent: {
    service: {
      name: 'uicontent',
      title: 'UI Content',
      key: 'rid',
      num: true,
      fields: ['rid','eni','enn','enc','rfi','dci','dcn','dcc','pgi','pgn','pgc','sci','scn','scc','dvi','dvn','dvc','lgi','lgn','lgc','msg','dsc','amk','sts','ast','stp',],
      params: {nam: 'Context',shc: 'Code',dsc: 'Description',dba: 'Debi Account',cda: 'Credit Account',sts: 'Status',},
      grid: [['enn', 'Entity'],['rfi', 'Refid'],['dcn', 'Document'],['pgn', 'Page'],['scn', 'Section'],['dvn', 'Device'],['lgn', 'Language'],['amk', 'Access Mask'],['sts', 'Status'],['stp', 'Stamp'],],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Entity', v: 'enn' },{ t: 'Document', v: 'dcc' },],def: 'enn'},
      eform: [
        { id: 'eni',label: 'Entity',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'entity' }},
        { id: 'rfi', label: 'Ref ID', type: 'nf', req: 1, ops: {} },
        { id: 'dci',label: 'Document',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'uidoc' }},
        { id: 'pgi',label: 'Page',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'uipage' }},
        { id: 'sci',label: 'Section',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'uisection' }},
        { id: 'dvi',label: 'Device',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'uidevice' }},
        { id: 'lgi',label: 'Language',type: 'fa',req: 1,ops: {},cp: { t: 'bcs', s: 'uilang' }},
        { id: 'msg', label: 'Message', type: 'ta', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'amk',label: 'Access Mask',type: 'nf',req: 0,ops: { pattern: '[0-9]+' }},
        { id: 'sts',label: 'Status',type: 'fa',req: 0,ops: {},cp: { t: 'lcs', s: 'status' }},
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete',view: 'View'},
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }},

  user: {
    service: {
      name: 'user',
      title: 'User',
      fields: ['rid','fnm','onm','snm','nam','unm','roi','rnm','eti','ety','eni','enm','pla','ila','flg','ct1','ct2','eml','sid','sto','lst','dct','lld','lpd','mct','bri','brn','bcd','tli','tla','lvi','lvn','rmk','sts','ast','stp',],
      grid: [['nam', 'Name'],['rnm', 'Role'],['ety', 'EntityType'],['enm', 'Entity'],['ct1', 'Mobile'],['eml', 'Email'],['lvn', 'Loglevel'],['lst', 'Login'],['ast', 'Status'],['stp', 'Stamp'],],
	    menu: {mnu: [{ t: 'Name', v: 'nam' },{ t: 'Mobile', v: 'mbn' },],def: 'nam',},
      eform: [
        { id: 'fnm', label: 'Firstname', type: 'tf', col: 1, req: 1, ops: {} },
        { id: 'onm', label: 'Othernames', type: 'tf', col: 1, req: 0, ops: {} },
        { id: 'snm', label: 'Surname', type: 'tf', col: 1, req: 1, ops: {} },
        { id: 'unm', label: 'Username', type: 'tf', col: 1, req: 1, ops: {} },
        { id: 'eti',label: 'Entity Type',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'bcs', s: 'entitytype' },chs: ['eni', 'roi'],},
        { id: 'eni',label: 'Entity',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'bcs', s: 'entity' },pns: ['eti'],},
        { id: 'roi',label: 'Role',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'bcs', s: 'role' },pns: ['eti']},
        { id: 'rfi',label: 'Branch',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'lcs', s: 'branch' }},
        { id: 'sts',label: 'Status',type: 'fa',col: 1,req: 1,ops: {},cp: { t: 'lcs', s: 'status' }},
        { id: 'ct1',label: 'Mobile',type: 'tf',col: 2,req: 1,ops: { type: 'tel' }},
        { id: 'ct2', label: 'Contact', type: 'tf', col: 2, req: 0, ops: {} },
        { id: 'eml',label: 'Email',type: 'tf',col: 2,req: 1,ops: { type: 'email' }},
        { id: 'pla',label: 'Login Attempts',type: 'nf',col: 2,req: 0,ops: {},off: ['add']},
        { id: 'sto',label: 'Session Timeout',type: 'nf',col: 2,req: 0,ops: {},},
        { id: 'flg',label: 'False Login',type: 'nf',col: 2,req: 0,ops: {},},
        { id: 'lst',label: 'Login Status',type: 'fa',col: 2,req: 0,ops: {},cp: { t: 'bcs', s: 'loginstatus' }},
        { id: 'lvi',label: 'Log Level',type: 'fa',col: 2,req: 0,ops: {},cp: { t: 'bcs', s: 'loglevel' }},
        { id: 'com', label: 'Comments', type: 'ta', col: 2, req: 0, ops: {} },
      ],
    },
    create: true,
    actions: {
      add: 'Add',
      edit: 'Edit',
      del: 'Delete',
      delete: 'Delete',
      view: 'View',
      reset: 'simple',
    },
    panels: {
      add: 'column',
      edit: 'column',
      delete: 'dialog',
      view: 'column',
      close: 'dialog',
    }},
};

export { serviceconfig };
